import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------SubAdmin-listing--------------------------
export const getSubAdminListAPI = async (page = 1, limit = 10, search = "") => {
  // const endPoint =
  //   `sub-admin/list` + "?" + new URLSearchParams({ ...data }).toString();

  const endPoint = `admin/sub-admin/list?pagination=&page=${page}&limit=${limit}&search=${search}`;

  return await axios.get(endPoint, setJwtToken());
};

// --------------------- get Sub Admin Details --------------------------
export const getSubAdminDetailsAPI = async (subAdId) => {
  const endPoint = `admin/sub-admin?_id=${subAdId}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add SudAdmin------------------
export const createSubAdminAPI = async (data) => {
  console.log("I AM TOKEN", setJwtToken());
  const endPoint = `admin/sub-admin`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ------------------------Edit SubAdmin------------------
export const editSubAdminApi = async (data) => {
  const endPoint = `admin/sub-admin`;
  return await axios.put(endPoint, data, setJwtToken());
};

// -------------------------Change SubAdmin Status------------
export const changeSubAdminStatusApi = async (data) => {
  const endPoint = `sub-admin/change-status`;
  return await axios.put(endPoint, data, setJwtToken());
};

// -------------------------Delete SubAdmin ------------
export const deleteSubAdminApi = async (data) => {
  const endPoint = `sub-admin/delete/${data}`;
  return await axios.delete(endPoint, setJwtToken());
};

// ------------------------Resend Mail------------------
export const resendMailSubAdminApi = async (data) => {
  const endPoint = `sub-admin/resend-email`;
  return await axios.post(endPoint, data, setJwtToken());
};
